import moment from 'moment-timezone';
import store from './vuex/store'

function toUtcString(datetime){    
    return moment.tz(datetime, "YYYY-MM-DD HH:mm:ss", store.getters.timezone).tz('utc').format("YYYY-MM-DD HH:mm:ss");    
}

function utcToLocalString(datetime){
    return moment.tz(datetime, "YYYY-MM-DD HH:mm:ss", 'utc').tz(store.getters.timezone).format("YYYY-MM-DD HH:mm:ss");    
}

function toUtc(datetime){    
    return moment.tz(datetime, "YYYY-MM-DD HH:mm:ss", store.getters.timezone).tz('utc')
}

function utcToLocal(datetime){    
    return moment.tz(datetime, "YYYY-MM-DD HH:mm:ss", 'utc').tz(store.getters.timezone)
}

function utcToLocalDisplay(datetime){    
    
    return moment.tz(datetime, "YYYY-MM-DD HH:mm:ss", 'utc').tz(store.getters.timezone).format('ddd, D MMM YYYY, HH:mm a')
}

function setTimezone(timezone){    
    if(timezone && timezone.length !== 0){
        moment.tz.setDefault(timezone)
    }        
}

export {moment, toUtcString, utcToLocalString, toUtc, utcToLocal, setTimezone,utcToLocalDisplay};